import styled from 'styled-components';

export const AlignContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 12px;
  margin-bottom: 50px;
`;

export const AlignRowColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AlignRow = styled.div`
  display: flex;
  gap: 12px;
`;
